import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getCookie, loadScriptsSequentially } from '../utils';
import moment from 'moment';
import './RoadMap.css'; 

function RoadMap() {
    // const [sites, setSites] = useState([]);
    const [faqCategories, setFaqCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState(null);
    const [roadMap, setRoadMap] = useState([]);

      //questo mi serve per stile di questa pagina
    useEffect(() => {
        document.body.style.backgroundColor = "#0a0a0a";
        return () => {
            document.body.style.backgroundColor = "";
        };
    }, []);  



    useEffect(() => {
        const fetchRoadMapData = async () => {
            try {
                const response = await fetch('https://sales.huberway.com/api/projects/4/tasks', {
                    method: 'GET', // Assicurati di non usare 'no-cors'
                });
    
                if (!response.ok) {
                    throw new Error('Impossibile recuperare i dati della roadmap');
                }
    
                const data = await response.json();
                const tasks = data.tasks || [];
    
                const mappedTasks = tasks.map(task => ({
                    title: task.name,
                    content: task.description,
                    date: task.duedate
                }));
    
                setRoadMap(mappedTasks);
                console.log(mappedTasks); 
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.error('Error:', error);
            }
        };
    
        fetchRoadMapData();
    }, []);
    


    useEffect(() => {
        // Carica jQuery e altri script necessari
        const script = document.createElement('script');
        script.src = "https://app.huberway.org/assets/plugins/jquery/jquery-3.2.1.min.js?v=" + Date.now();
        script.onload = () => {
            loadScriptsSequentially([
                "js/pre-loader.js",
                "assets/bootstrap/js/popper.min.js",
                "assets/bootstrap/js/bootstrap.min.js",
                "js/parallaxie.js",
                "js/TweenMax.min.js",
                "js/jquery.wavify.js",
                "assets/wow/wow.min.js",
                "assets/counterup/jquery.counterup.min.js",
                "assets/counterup/jquery.waypoints.min.js",
                "js/main.js",
            ]);
        };
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const handleCategoryClick = (categoryId) => {
        setActiveCategory(categoryId);
    };

    return (
        <>
    <div className="page-wrapper">
      <div className="section-timeline-heading">
        <div className="container">
          <div className="padding-vertical-xlarge">
          <div className="timeline-main_heading-wrapper">
            <div className="margin-bottom-medium">
                <h1 className='road-title'>Psicopatici: Roadmap</h1>
            </div>
            <p className="paragraph-large">
                In questa roadmap, troverai una panoramica delle principali fasi del progetto, includendo ciò che è stato completato e
                ciò che è previsto nei prossimi mesi per garantire che il nostro sistema sia sicuro, affidabile e all'avanguardia.
            </p>
            </div>
          </div>
        </div>
      </div>
      <div className="section-timeline">
        <div className="container">
          <div className="timeline_component">
            <div className="timeline_progress">
              <div className="timeline_progress-bar"></div>
            </div>
            {roadMap.map((item, index) => {
              const formattedDate = moment(item.date).format('MMMM YYYY');

              return (
                <div className="timeline_item" key={index}>
                  <div className="timeline_left">
                    <div className="timeline_date-text">{formattedDate}</div>
                  </div>
                  <div className="timeline_centre">
                    <div className="timeline_circle"></div>
                  </div>
                  <div className="timeline_right">
                    <div className='timeline-title'>
                        {item.title}
                    </div>
                    <div className="margin-bottom-medium">
                      <div className="timeline_text" dangerouslySetInnerHTML={{ __html: item.content }} />
                    </div>
                  </div>
                </div>
              );
            })}

            <div className="overlay-fade-top"></div>
            <div className="overlay-fade-bottom"></div>
          </div>
        </div>

      </div>
    </div>
        </>
    );
}

export default RoadMap;

